export const SET_IS_SCREEN_SHARING_REQUIRED = "SET_IS_SCREEN_SHARING_REQUIRED";
export const SET_IS_SCREEN_SHARED = "SET_IS_SCREEN_SHARED";
export const SET_SCREEN_STREAM = "SET_SCREEN_STREAM";
